@if (hasPermission()) {
    <section class="main">
        <div class="header-wrapper">
            <div class="title-wrapper">
                <h2 class="main-title">Email Notifications</h2>
                <div>
                    <div class="date-picker-container">
                        <button #rangeButton class="date-select-btn range-button" type="button" aria-haspopup="dialog"
                                [attr.aria-expanded]="isDateRangePickerOpened" aria-controls="email-range-dialog"
                                (click)="openDateRangePicker()">
                            <i class="bi bi-calendar3" aria-hidden="true"></i>
                            <span>{{ emailNotificationsService.startDate | date:'dd MMM yyyy, HH:mm' }} – {{ emailNotificationsService.endDate | date:'dd MMM yyyy, HH:mm' }}</span>
                        </button>

                        <button class="date-select-btn refresh-btn" type="button" (click)="refreshTable()" aria-label="Refresh email notifications" title="Reset to today">
                            <i class="bi bi-arrow-clockwise" aria-hidden="true"></i>
                        </button>

                        <dialog #rangeDialog id="email-range-dialog" class="range-dialog"
                                aria-labelledby="email-range-title" (close)="onDateRangePickerClosed()"
                                (click)="onDateRangeBackdropClick($event)">
                            <div class="range-dialog-heading">
                                <h2 id="email-range-title">Select period</h2>
                                <button class="range-close" type="button" aria-label="Close date picker"
                                        (click)="closeDateRangePicker()"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
                            </div>
                            <form class="range-form" (ngSubmit)="applyDateRange()">
                                <label>From<input type="datetime-local" name="startDate" [(ngModel)]="draftStart" [max]="maxDateTime" required></label>
                                <label>To<input type="datetime-local" name="endDate" [(ngModel)]="draftEnd" [max]="maxDateTime" required></label>
                                @if (draftRangeError) { <p class="range-error" role="alert">{{ draftRangeError }}</p> }
                                <div class="range-dialog-actions">
                                    <span></span>
                                    <button class="cancel-button" type="button" (click)="closeDateRangePicker()">Cancel</button>
                                    <button class="apply-button" type="submit">Apply range</button>
                                </div>
                            </form>
                        </dialog>
                    </div>

                </div>
            </div>


<!--            @if (emailNotificationsService.isLoading()) {-->
<!--                <div class="loading">-->
<!--                    Loading email notifications...-->
<!--                </div>-->
<!--            }-->

            @if (emailNotificationsService.customerSummary().length > 0) {
                <div class="table-container"
                     infinite-scroll
                     [scrollWindow]="false"
                     [infiniteScrollDistance]="2"
                     (scroll)="onScroll()">
                    <table>
                        <tr class="header">
                            <th>Customer Number</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Last Purchase</th>
                        </tr>
                        @for (customer of emailNotificationsService.customerSummary(); track customer.customerNumber) {
                            <tr class="body-columns"
                                (click)="openCustomerEmailDetails(customer.customerNumber, customer.email)"
                                style="cursor: pointer;">
                                <td>{{ customer.customerNumber }}</td>
                                <td>{{ customer.name }}</td>
                                <td>{{ customer.email }}</td>
                                <td>{{ customer.lastPurchaseAt }}</td>
                            </tr>


                        }

                    </table>
                </div>
            } @else if (!emailNotificationsService.isLoading()) {
                <div class="no-data">
                    No email notifications found for the selected period.
                </div>
            }
        </div>
    </section>
}

